import React from "react";

function getPosition(string, subString, index) {
  if (index == 0) {
    return 0;
  }
  return string.split(subString, index).join(subString).length + 1;
}

function Case(props) {
  return (
    <div className="col-lg-4 col-md-6 col-sm-6 col-12 my-2">
      <div className="card border-light">
        <div className="card-header">
          <h6>
            {props.name}
            <small className="d-block text-success">{props.probability}%</small>
          </h6>
        </div>
        <div className="card-img-top">
          <img src={props.top} width="50%"></img>
          <img src={props.bottom} width="50%"></img>
        </div>
        <div className="card-body" style={{ marginTop: "-1.5rem" }}>
          <ul class="list-group list-group-flush">
            <li class="list-group-item h6">
              <span className="text-success d-block">Odd:</span>
              {props.odd ? (
                props.odd.map((oddCase, index) => (
                  <div className="mb-1">
                    {props.oddPar[index] > 0 ? (
                      <mark>
                        {oddCase.substring(
                          0,
                          getPosition(oddCase, "/", props.oddPar[index])
                        )}
                      </mark>
                    ) : (
                      <span></span>
                    )}
                    {oddCase.substring(
                      getPosition(oddCase, "/", props.oddPar[index])
                    )}
                  </div>
                ))
              ) : (
                <div></div>
              )}
            </li>
            <li class="list-group-item h6">
              <span className="text-success d-block">Even:</span>{" "}
              {props.even ? (
                props.even.map((evenCase, index) => (
                  <div className="mb-1">
                    {props.evenPar[index] > 0 ? (
                      <mark>
                        {evenCase.substring(
                          0,
                          getPosition(evenCase, "/", props.evenPar[index])
                        )}
                      </mark>
                    ) : (
                      <span></span>
                    )}
                    {evenCase.substring(
                      getPosition(evenCase, "/", props.evenPar[index])
                    )}
                  </div>
                ))
              ) : (
                <div></div>
              )}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Case;
